import React, { useEffect, useState } from "react";
import { Grid, IconButton, InputAdornment } from "@mui/material";
import { FnAxios, FnDialog, I18n } from "utilities/utilities";
import DialogPreview from "components/DialogPreview/DialogPreview";
import { TextBoxItem } from "components/Input/TextBox";
import { FormProvider, useForm } from 'react-hook-form';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import VisibilityIcon from '@mui/icons-material/Visibility';

import { GetUserAccout } from "utilities/SystemFunction";
import { APIStatusCode, I18NextNs } from "enum/enum";
import { ApiUserChange } from "enum/api";
import { BtnBaseButton, BtnSave } from "components/Button/ButtonAll";

const ChangePassword = (props: IChangePassword) => {
    const DialogFn = FnDialog();
    const AxiosFn = FnAxios();

    const [isIconEyeNew, setisIconEyeNew] = useState(false);
    const [isIconEyeConfirm, setisIconEyeConfirm] = useState(false);
    const [isIconEyeOld, setisIconEyeOld] = useState(false);
    const [sPWD, setsPWD] = useState(null);

    // const form = useForm({
    //     shouldUnregister: false,
    //     shouldFocusError: true,
    //     mode: "all",
    // });

    const form = useForm({
        shouldFocusError: true,
        mode: "all",
        defaultValues: {} as any,
    });

    const handleClickShowSecuredCodeNew = () => setisIconEyeNew((show) => !show);
    const handleMouseDownSecuredCodeNew = (event: React.MouseEvent<HTMLButtonElement>) => {
        event.preventDefault();
    };

    const handleClickShowSecuredCodeConfirm = () => setisIconEyeConfirm((show) => !show);
    const handleMouseDownSecuredCodeConfirm = (event: React.MouseEvent<HTMLButtonElement>) => {
        event.preventDefault();
    };

    const handleClickShowSecuredCodeOld = () => setisIconEyeOld((show) => !show);
    const handleMouseDownSecuredCodeOld = (event: React.MouseEvent<HTMLButtonElement>) => {
        event.preventDefault();
    };

    useEffect(() => {
        let objUser: IAvatar = GetUserAccout();
        setsPWD(objUser?.sSecuredCode);
    }, []);

    const onSubmit = () => {
        let isSubmit = false;
        let sPWDOld = form.getValues("txtPWDOld");
        let sPWDNew = form.getValues("txtPWDNew");
        let sPWDConfirm = form.getValues("txtPWDConfirm");        
        let isError = false;
        if (sPWDOld === sPWD) {
            isSubmit = true;
        } else {
            isSubmit = false;
            isError = true;
            form.setError('txtPWDOld', { type: 'value', message: `${I18n.SetText("msgPassword")}` }, { shouldFocus: false, }); //รหัสผ่านเดิมไม่ถูกต้อง
        }
        if (sPWDNew !== sPWD) {
            isSubmit = true;
        } else {
            isSubmit = false;
            isError = true;
            form.setError('txtPWDNew', { type: 'value', message: `${I18n.SetText("msgChangePassword")}` }, { shouldFocus: false, }); //รหัสผ่านใหม่ไม่ควรตรงกันกั
        }
        if (sPWDNew === sPWDConfirm) {
            isSubmit = true;
        } else {
            isSubmit = false;
            isError = true;
            form.setError('txtPWDConfirm', { type: 'value', message: `${I18n.SetText("msgChangePasswordConfirm")}` }, { shouldFocus: false, }); //รหัสผ่านไม่ต
        }   
        if (isError === true) return;            

        if (isSubmit === true) 
        {
            let ObjParam = {
                sPWDNew: form.getValues("txtPWDNew"),
                sPWDConfirm: form.getValues("txtPWDConfirm"),
                sPWDOld: form.getValues("txtPWDOld"),

                isChangePasswordLogin: props.isChangePasswordLogin, //True = ล็อกอินมา
                sEmail: form.getValues("sEmail"),
            };
            DialogFn.Submit(I18n.SetText("Message.ConfirmSave", I18NextNs.labelComponent), () => {
                DialogFn.BlockUI();
                AxiosFn.Post(ApiUserChange.ChangeSecuredCode, ObjParam, (result) => {
                    DialogFn.UnBlockUI();
                    if (result.nStatusCode === APIStatusCode.Success) {
                        DialogFn.Success(I18n.SetText("Message.SaveComplete", I18NextNs.labelComponent));
                        DialogFn.CloseSubmit();
                        if (props.setisOpen) props.setisOpen(false);
                    }
                    else if (result.nStatusCode === APIStatusCode.Warning) {
                        DialogFn.Warning(result.sMessage);
                    }
                },
                    (err) => {
                        DialogFn.UnBlockUI();
                        if (!err.response) {
                            DialogFn.Warning(err.sMessage);
                        }
                    });
            });
        }
    };

    useEffect(() => {
        if (props.isChangePasswordLogin === false && (props.sEmail ?? null) !== null && (props.sSecuredCode ?? null) !== null) 
        {
            form.setValue("sEmail", props.sEmail); 
            setsPWD(props.sSecuredCode);
        }
    }, [props.isChangePasswordLogin, props.sEmail, props.sSecuredCode]);

    return (     
        <Grid item container spacing={2} justifyContent={"center"} alignItems={"center"} alignContent={"center"}>
            <FormProvider {...form}>
                <DialogPreview
                    IsOpen={props.isOpen}
                    Title={I18n.SetText("changepassword")}
                    IsBackdropClick={false}
                    onClose={() => { if (props.setisOpen) props.setisOpen(false); }}
                    bgColor={"rgb(191 124 46)"}
                    Color={"#ffffff"}
                    JsxDialogAction
                    sMaxWidth="xs"
                    required={true}
                    Close={false}
                    CloseSave={true}
                    onClick={form.handleSubmit((e) => onSubmit(), (err) => console.log("err", err))}
                    sTitleBtnSave={`${I18n.SetText("confirmpasswordnew")}`}
                >
                    <Grid item container spacing={2} justifyContent={"center"} alignItems={"center"} alignContent={"center"}>
                        <Grid item xs={12} md={12} container spacing={2} justifyContent={"center"} alignItems={"flex-start"} alignContent={"flex-start"}>
                            {props.isChangePasswordLogin === false &&
                                <Grid item xs={12} md={11}>
                                    <TextBoxItem
                                        id={"sEmail"}
                                        name={"sEmail"}
                                        maxLength={150}
                                        label={`${I18n.SetText("username")}`}
                                        required={false}
                                        type={"email"}                                    
                                        autoComplete="email"
                                        IsShowTextCont={false}
                                        disabled={true}
                                    />
                                </Grid>
                            }
                            <Grid item xs={12} md={11}>
                                <TextBoxItem
                                    id={"txtPWDOld"}
                                    name="txtPWDOld"
                                    label={`${I18n.SetText("confirmpasswordold")}`}
                                    maxLength={20}
                                    required={true}
                                    disabled={false}
                                    type={isIconEyeOld ? "text" : "password"}
                                    isPassword={true} //กรณีเปลี่ยน Type ระหว่าง text กับ password จะต้องมีเช็ค Pattern Password ด้วย ถ้าเป็น text
                                    isNotPatternPassword={true} //ไม่เอาดัน Pattern Password
                                    IsShowTextCont={false}
                                    endAdornment={
                                        <InputAdornment position="end">
                                            <IconButton
                                                aria-label="toggle password visibility"
                                                onClick={handleClickShowSecuredCodeOld}
                                                onMouseDown={handleMouseDownSecuredCodeOld}
                                                edge="end"
                                            >
                                                {isIconEyeOld ? <VisibilityOffIcon style={{ color: '#202178' }} /> : <VisibilityIcon style={{ color: '#202178' }} />}
                                            </IconButton>
                                        </InputAdornment>
                                    }
                                    onBlur={(Objvalue) => {
                                        let sValue = Objvalue.target.value;
                                        let sPWDNew = form.getValues("txtPWDNew");
                                        let sPWDConfirm = form.getValues("txtPWDConfirm");
                                        if (sValue === sPWDNew || sValue === sPWDConfirm) {
                                            form.setError('txtPWDOld', { type: 'value', message: `${I18n.SetText("msgChangePassword")}` }, { shouldFocus: false, }); //รหัสผ่านใหม่ไม่ควรตรงกันกับรหัสผ่านเดิม
                                        } else if (sValue !== sPWD) {
                                            form.setError('txtPWDOld', { type: 'value', message: `${I18n.SetText("msgPassword")}` }, { shouldFocus: false, }); //รหัสผ่านเดิมไม่ถูกต้อง
                                        }
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12} md={11}>
                                <TextBoxItem
                                    id={"txtPWDNew"}
                                    name="txtPWDNew"
                                    label={`${I18n.SetText("passwordnew")}`}
                                    maxLength={20}
                                    required={true}
                                    disabled={false}
                                    IsShowTextCont={false}
                                    type={isIconEyeNew ? "text" : "password"}
                                    isPassword={true} //กรณีเปลี่ยน Type ระหว่าง text กับ password จะต้องมีเช็ค Pattern Password ด้วย ถ้าเป็น text
                                    endAdornment={
                                        <InputAdornment position="end">
                                            <IconButton
                                                aria-label="toggle password visibility"
                                                onClick={handleClickShowSecuredCodeNew}
                                                onMouseDown={handleMouseDownSecuredCodeNew}
                                                edge="end"
                                            >
                                                {isIconEyeNew ? <VisibilityOffIcon style={{ color: '#202178' }} /> : <VisibilityIcon style={{ color: '#202178' }} />}
                                            </IconButton>
                                        </InputAdornment>
                                    }
                                    onBlur={(Objvalue) => {
                                        let sValue = Objvalue.target.value;
                                        let sPWDOld = form.getValues("txtPWDOld");
                                        if (sValue === sPWDOld) form.setError('txtPWDNew', { type: 'value', message: `${I18n.SetText("msgChangePassword")}` }, { shouldFocus: false, }); //รหัสผ่านใหม่ไม่ควรตรงกันกับรหัสผ่านเดิม
                                        let sPWDConfirm = form.getValues("txtPWDConfirm");
                                        if (sPWDConfirm !== null){
                                            if (sValue === sPWDConfirm) {
                                                form.clearErrors('txtPWDConfirm'); //รหัสผ่านตรงกันแล้ว  
                                            } else {
                                                form.setError('txtPWDConfirm', { type: 'value', message: `${I18n.SetText("msgChangePasswordConfirm")}` }, { shouldFocus: false, }); //รหัสผ่านไม่ตรงกัน
                                            }
                                        }     
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12} md={11}>
                                <TextBoxItem
                                    id={"txtPWDConfirm"}
                                    name="txtPWDConfirm"
                                    label={`${I18n.SetText("confirmpassword")}`}
                                    maxLength={20}
                                    required={true}
                                    disabled={false}
                                    type={isIconEyeConfirm ? "text" : "password"}
                                    isPassword={true} //กรณีเปลี่ยน Type ระหว่าง text กับ password จะต้องมีเช็ค Pattern Password ด้วย ถ้าเป็น text
                                    IsShowTextCont={false}
                                    endAdornment={
                                        <InputAdornment position="end">
                                            <IconButton
                                                aria-label="toggle password visibility"
                                                onClick={handleClickShowSecuredCodeConfirm}
                                                onMouseDown={handleMouseDownSecuredCodeConfirm}
                                                edge="end"
                                            >
                                                {isIconEyeConfirm ? <VisibilityOffIcon style={{ color: '#202178' }} /> : <VisibilityIcon style={{ color: '#202178' }} />}
                                            </IconButton>
                                        </InputAdornment>
                                    }
                                    onBlur={(Objvalue) => {
                                        let sValue = Objvalue.target.value;
                                        let sPWDNew = form.getValues("txtPWDNew");
                                        if (sValue !== sPWDNew) form.setError('txtPWDConfirm', { type: 'value', message: `${I18n.SetText("msgChangePasswordConfirm")}` }, { shouldFocus: false, }); //รหัสผ่านไม่ตรงกัน                                    
                                        let sPWDOld = form.getValues("txtPWDOld");
                                        if (sValue === sPWDOld) form.setError('txtPWDConfirm', { type: 'value', message: `${I18n.SetText("msgChangePassword")}` }, { shouldFocus: false, }); //รหัสผ่านใหม่ไม่ควรตรงกันกับรหัสผ่านเดิม                                    
                                    }}
                                />
                            </Grid>                        
                        </Grid>
                        {/* <Grid item xs={12} md={12} container spacing={1} justifyContent="center">                      
                            <BtnSave
                                id={"btnSave"} 
                                txt={`${I18n.SetText("confirmpasswordnew")}`} 
                                onClick={()=>{
                                    let isSubmit = false;

                                    let sPWDOld = form.getValues("txtPWDOld");
                                    let sPWDNew = form.getValues("txtPWDNew");
                                    let sPWDConfirm = form.getValues("txtPWDConfirm");

                                    if (sPWDOld === sPWD) {
                                        isSubmit = true;
                                    } else {
                                        form.setError('txtPWDOld', { type: 'value', message: `${I18n.SetText("msgPassword")}` }, { shouldFocus: false, }); //รหัสผ่านเดิมไม่ถูกต้อง
                                    }
                                    if (sPWDNew !== sPWD) {
                                        isSubmit = true;
                                    } else {
                                        form.setError('txtPWDNew', { type: 'value', message: `${I18n.SetText("msgChangePassword")}` }, { shouldFocus: false, }); //รหัสผ่านใหม่ไม่ควรตรงกันกับรหัสผ่านเดิม
                                    }
                                    if (sPWDNew === sPWDConfirm) {
                                        isSubmit = true;
                                    } else {
                                        form.setError('txtPWDConfirm', { type: 'value', message: `${I18n.SetText("msgChangePasswordConfirm")}` }, { shouldFocus: false, }); //รหัสผ่านไม่ตรงกัน
                                    }   

                                    if (isSubmit === true) {
                                        form.handleSubmit((e) => onSubmit(),(err) => { 
                                            document.getElementById(Object.keys(err)[0])?.focus();
                                        })
                                    }
                                }}
                            />
                        </Grid> */}
                    </Grid>
                </DialogPreview>
            </FormProvider>
        </Grid>
    )
}
export default ChangePassword;